import React from "react";
import { Box, Button } from "@mui/material";
import { useResponsiveStyles } from "../../../styles/useResponsiveStyles";
export const MultiSelectActions = ({ onCancel, onApply }) => {
    const {getContainerHeight, getFontSize} = useResponsiveStyles()
    return <Box
        sx={{
            display: "flex",
            justifyContent: "space-between",
            p: 0.5,
        }}
    >
        <Button
            variant="outlined"
            onClick={onCancel}
            sx={{
                color: "#ef4444",
                textTransform: "none",
                borderColor: "#ef4444",
                ...getContainerHeight('filter-height'),
                ...getFontSize('body1')
            }}
        >
            Cancel
        </Button>
        <Button
            variant="contained"
            onClick={onApply}
            sx={{
                bgcolor: "#ef4444",
                color: "white",
                textTransform: "none",
                ...getContainerHeight('filter-height'),
                ...getFontSize('body1')
            }}
        >
            Apply
        </Button>
    </Box>
};
